export default "__VITE_ASSET__Dxv$qz3T__"